import { axiosAuth } from './axiosInstances'

// KHAN-227: apps.Pages -> apps.pages, verbos-en-path -> recurso REST +
// metodo HTTP. Ver funread_backend/apps/pages/views.py para el mapeo
// completo old->new.
export async function listAllPages(bookid) {
  return axiosAuth().get('pages/', {
    params: { book: bookid }
  });
}
export async function updatePageType(pageid, type) {

  return axiosAuth().patch(`pages/${pageid}/`, {
    type,
  });
}

export async function newPage(bookid, type, template, elementorder, gridDirection, gridNumRows) {

  return axiosAuth().post("pages/", {
    bookid,
    type,
    template,
    elementorder,
    gridDirection,
    gridNumRows,
  });
}

export async function deletePage(pageid) {
  return axiosAuth().delete(`pages/${pageid}/`);
}

export async function swapPages(pageid1, pageid2) {
  return axiosAuth().post('pages/reorder/', {
    pageid1,
    pageid2,
  });
}

